var render, staticRenderFns
import script from "./MixinUploadDocument.vue?vue&type=script&lang=js&"
export * from "./MixinUploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./MixinUploadDocument.vue?vue&type=style&index=0&id=57d0c024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0c024",
  null
  
)

export default component.exports